function Result(props) {
  return (
      <div className='result'>
          <h1>{props.winMessage}</h1>
      </div>
  );
}

export default Result;